import React from 'react';
const facts = [{
  value: '54',
  label: 'Ready-to-adapt sessions'
}, {
  value: '6 + 5',
  label: 'Volumes & bonuses'
}, {
  value: '3',
  label: 'Energy versions per session'
}, {
  value: '24',
  label: 'Printable worksheets'
}];
export function SocialProofBar() {
  return <section className="w-full bg-light" data-id="element-314" data-mp="25suajgoklzlz">
      <div className="max-w-6xl mx-auto px-5 pb-14 sm:pb-16" data-id="element-315" data-mp="25tvnxrt26y6v">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-line bg-line shadow-card sm:grid-cols-4" data-id="element-316" data-mp="32iuv13hwptxh">
          {facts.map(fact => <div key={fact.label} className="bg-white px-4 py-5 text-center" data-id="element-317" data-mp="2xhxcgpszixvg">
              <div className="font-display text-3xl font-bold sm:text-4xl leading-none text-court-deep" data-id="element-318" data-mp="2tgvaw2bli9qb">
                {fact.value}
              </div>
              <div className="mt-1.5 text-[10px] font-bold uppercase tracking-widest text-ink-muted" data-id="element-319" data-mp="1i2zzn4ntal4d">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}